'use client'

import { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import { DataTableColumnHeader } from '../../../components/shared/data-table/data-table-column-header'

export type GroupComponent = {
  id: number
  code: string
  component_sku: string | null
  image: {
    src_thumbnail: string | null
  } | null
  additional_component_profiles: Array<{
    name: string
    language: string
  }>
  _count: {
    additional_component_to_advanced_product: number
  }
}

export const componentColumns: ColumnDef<GroupComponent>[] = [
  {
    accessorKey: 'image',
    header: () => null,
    cell: ({ row }) => {
      const src = row.original.image?.src_thumbnail
      return src ? (
        <img
          src={src}
          alt={row.original.code}
          className="h-8 w-8 rounded object-cover"
        />
      ) : (
        <div className="h-8 w-8 rounded bg-muted" />
      )
    },
    enableSorting: false,
    enableHiding: false,
    meta: { width: '60px' },
  },
  {
    accessorKey: 'name',
    id: 'name',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    enableSorting: false,
    enableHiding: true,
    cell: ({ row }) => {
      const profile = row.original.additional_component_profiles?.[0]
      const name = profile?.name
      const code = row.original.code
      return (
        <div className="flex flex-col space-y-1">
          {name && (
            <span className="max-w-[500px] truncate font-medium">{name}</span>
          )}
          {code && (
            <span className="max-w-[500px] truncate text-sm text-muted-foreground font-mono">
              {code}
            </span>
          )}
        </div>
      )
    },
  },
  {
    accessorKey: 'component_sku',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="SKU" />
    ),
    enableSorting: true,
    enableHiding: true,
    cell: ({ row }) => (
      <span className="text-sm font-mono text-muted-foreground">
        {row.getValue('component_sku') || '-'}
      </span>
    ),
    meta: { width: '120px' },
  },
  {
    accessorKey: '_count',
    id: 'products',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Products" />
    ),
    enableSorting: false,
    enableHiding: true,
    cell: ({ row }) => {
      const count = row.original._count?.additional_component_to_advanced_product ?? 0
      return (
        <Badge variant={count > 0 ? 'default' : 'secondary'} className="text-xs">
          {count}
        </Badge>
      )
    },
    meta: { width: '100px' },
  },
]
